import mixin from '@general/lib/mixin'
import auth from '@general/lib/auth'
import discoverModule from "../../../discover/module/store/type";
import moment from "moment/moment";

export default e => {
    console.log('[Refresh listener] Signal received', e)
    store.commit('updateUser', e.data)
    store.commit(discoverModule.mutations.users.update, {
        userId:auth.getUserId(),
        fields: e.data
    })
}
